import React from "react";
import "./../comparativeAnalysis.less";
import Distribution from "./Distribution/Distribution";
import CalculateTask3DYCZTable from "./calculateTask3DYCZ_table";
import Hydraulics from "./Hydraulics";

interface TowerResultComponentProps {
  input: any;
  transInput: any;
  transInputs: any[]; // 每个任务对应的 input 数据
  results: any[]; // 多任务结果
  selectTreeButton: string;
  scrollViewRef: React.RefObject<HTMLDivElement>;
  selectResultPage: string;
}

const TowerResultComponent = ({
  input,
  transInput,
  transInputs,
  results,
  selectTreeButton,
  scrollViewRef,
  selectResultPage
}: TowerResultComponentProps) => {
  // 🔺 改动1：不再只取第一个任务，而是取所有任务的流股数据
  // 🔺 改动2：提取任务列表（用于表格列名展示，可根据实际字段调整）
  const taskList = results.map((taskItem) => ({
    taskId: taskItem.taskId,
    taskName: `${taskItem.name}(${taskItem.taskId})`,
    streams: taskItem.output.streams,
  }));

  const allTaskStreams = taskList.map(t => t.streams);

  // 筛选当前选中设备的输入数据（保持不变）
  const currentElementInput = input?.elements?.filter(
    (item: any) => item?.name === selectTreeButton
  )[0];
  console.log("transInput:",transInput);

  return (
    <div className="tower-result-container">
      {selectResultPage === "工艺计算结果" ? (
        <>
          <div className="distribution-section">
            <Distribution
              inputs={transInput}
              transInputs={transInputs}
              multiTaskResults={results.map((taskItem, index) => {
                const towerResult = taskItem.output?.elements
                  ?.filter((item: any) => item?.name === selectTreeButton)
                  ?.find((item: any) => item?.result)?.result || [];
                return {
                  taskId: taskItem.taskId,
                  taskName: `${taskItem.name}(${taskItem.taskId})`,
                  result: towerResult,
                  input: transInputs[index], // 每个任务对应的 input
                };
              })}
            />
          </div>

          <h3 className="detail-result-title">详细计算结果：</h3>
          <div className="table-section">
            <CalculateTask3DYCZTable
              inputData={input?.elements?.filter((item: any) => item?.name === selectTreeButton)}
              multiResultsData={allTaskStreams}
              taskList={taskList}
              streamsData={input?.streams?.filter((item: any) => item?.materials.length > 0)[0]}
              transInputs={transInputs}
            />
          </div>
          <div className="spacing-block"></div>
        </>
      ) : (
        // 🔺 改造：传递所有任务的水力学数据
        <div className="hydraulics-section multi-task-hydraulics">
          <Hydraulics
            scrollViewRef={scrollViewRef}
            multiTaskData={results.map((taskItem, index) => {
              const hydraulicsResult = taskItem.output?.elements
                ?.filter((item: any) => item?.name === selectTreeButton)[0];
              return {
                taskId: taskItem.taskId,
                taskName: `${taskItem.name}(${taskItem.taskId})`,
                result: hydraulicsResult,
                input: transInputs[index], // 每个任务对应的 input
              };
            })}
            inputs={currentElementInput}
          />
        </div>
      )}
    </div>
  );
};

export default TowerResultComponent;